<template>
  <div>
    <div class="bold fs22 pdBtm20 mrBtm20 borBtmdd">我的活动</div>
    <!--暂无活动-->
    <div style="padding: 10rem 0;">
      <el-empty description="暂无活动"></el-empty>
    </div>
  </div>
</template>

<script>
export default {
  name: "myEvent"
}
</script>

<style scoped>

</style>